import Client from 'config/axios';

export const InstagramToken = async (token: string) => {
  return await Client.get(`get-authentication-url/instagram`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
};
